export const QueryModuleNames = {
  exampleList: "example-list",
  exampleLookup: "example-lookup",
  customerList: "customer-list",
  customerStats: "customer-stats",
  customerLimits: "customer-limits",
  auditLogList: "audit-log-list",
  clientLookup: "client-lookup",
  clientPresetLookup: "client-preset-lookup",
  clientTypeLookup: "client-type-lookup",
  clientStatusLookup: "client-status-lookup",
  languageLookup: "language-lookup",
  countryLookup: "country-lookup",
  referenceCountries: "reference-countries",
  temperatureLookup: "temperature-lookup",
  currencyLookup: "currency-lookup",
  weightLookup: "weight-lookup",
  volumeLookup: "volume-lookup",
  fuelLookup: "fuel-lookup",
  distanceLookup: "distance-lookup",
  positionLookup: "position-lookup",
  productLookup: "product-lookup",
  clientSourceLookup: "client-source-lookup",
  clientCompetitorLookup: "client-competitor-lookup",
  clientPositionTypeLookup: "client-position-type-lookup",
  paymentTypeLookup: "payment-type-lookup",
  paymentLookup: "payment-lookup",
  paymentSubsUnitLookup: "payment-subs-unit-lookup",
  pprPaymentTermLookup: "ppr-payment-term-lookup",
  tireMakeLookup: "tire-make-lookup",
  vehicleList: "vehicle-list",
  commandHistoryList: "command-history-list",
  commandLookup: "command-lookup",
  commandDetail: "command-detail",
  commandHistoryDetail: "command-history-detail",
  routeHistory: "route-history",
  fuelLevelHistory: "fuel-level-history",
  fuelTanks: "fuel-tanks",
  fuelProbesCalibration: "fuel-probes-calibration",
  routeSettings: "route-settings",
  routePresetList: "route-preset-list",
  routePresetNames: "route-preset-names",
  routePresetDetail: "route-preset-detail",
  refuelingSettings: "refueling-settings",
  tachographSettings: "tachograph-settings",
  tachographCompanySettings: "tachograph-company-settings",
  refuelingPresetList: "refueling-preset-list",
  refuelingPresetLookup: "refueling-preset-lookup",
  connectivityHeatmap: "connectivity-heatmap",
  deviceIncomingLastValue: "device-incoming-last-value",
  deviceMappings: "device-mappings",
  mappingPresetList: "mapping-preset-list",
  mappingPresetDetail: "mapping-preset-detail",
  mappingPresetByDeviceType: "mapping-preset-by-device-type",
  mappingPresetNames: "mapping-preset-names",
  mappingPresetProperties: "mapping-preset-properties",
  temperatureTypeLookup: "temperature-type-lookup",
  relayStatusLookup: "relay-status-lookup",
  switchOnOffStateTypeLookup: "switch-on-off-state-type-lookup",
  warehouseUnitList: "warehouse-unit-list",
  warehouseUnitOperationTypeLookup: "warehouse-unit-operation-type-lookup",
  warehouseUnitHwStatusLookup: "warehouse-unit-hw-status-lookup",
  userList: "user-list",
  userDetail: "user-detail",
  userRoleLookup: "user-role-lookup",
  userDistributorLookup: "user-distributor-lookup",
  userClientLanguage: "user-client-language",
  userSystems: "user-systems",
  userActivities: "user-activities",
  userDevices: "user-devices",
  userTimedData: "user-timed-data",
  distributorLimitations: "distributor-limitations",
  distributorList: "distributor-list",
  unitManagementVehicleMakeLookup: "unit-management-vehicle-make-lookup",
  unitManagementVehicleModelLookup: "unit-management-vehicle-model-lookup",
  unitManagementVehicleTypeLookup: "unit-management-vehicle-type-lookup",
  unitManagementMaxSpeedLookup: "unit-management-max-speed-lookup",
  unitManagementAdjusterLookup: "unit-management-adjuster-lookup",
  unitManagementClientLookup: "unit-management-client-lookup",
  unitManagementUnitSearch: "unit-management-unit-search",
  unitManagementInstall: "unit-management-install",
  unitManagementVehicleSearch: "unit-management-vehicle-search",
  unitManagementVehicleDetail: "unit-management-vehicle-detail",
  unitManagementUninstall: "unit-management-uninstall",
  unitManagementUninstallFuelSensor: "unit-management-uninstall-fuel-sensor",
  unitManagementChange: "unit-management-change",
  userProfile: "user-profile",
  warehouseList: "warehouse-list",
  warehouseAreaList: "warehouse-area-list",
  warehouseLaneList: "warehouse-lane-list",
  warehouseShelfList: "warehouse-shelf-list",
  warehousePositionList: "warehouse-position-list",
  warehouseTypes: "warehouse-types",
  warehouseLookup: "warehouse-lookup",
  warehouseAreaLookup: "warehouse-area-lookup",
  warehouseLaneLookup: "warehouse-lane-lookup",
  warehouseShelfLookup: "warehouse-shelf-lookup",
  warehousePositionLookup: "warehouse-position-lookup",
  unitBrandList: "unit-brand-list",
  unitBrandLookup: "unit-brand-lookup",
  unitBrandColumns: "unit-brand-columns",
  unitModelList: "unit-model-list",
  unitModelColumns: "unit-model-columns",
  unitTypeLookup: "unit-type-lookup",
  temperatureSensorTypeList: "temperature-sensor-type-list",
  temperatureSensorTypeDetail: "temperature-sensor-type-detail",
  switchOnOffStateList: "switch-on-off-state-list",
  switchOnOffStateDetail: "switch-on-off-state-detail",
  relayStatusTypeList: "relay-status-type-list",
  relayStatusTypeDetail: "relay-status-type-detail",
  vehicleTypeList: "vehicle-type-list",
  vehicleMakeList: "vehicle-make-list",
  vehicleMakeLookup: "vehicle-make-lookup",
  vehicleModelList: "vehicle-model-list",
  modelPropertyList: "model-property-list",
  modelPropertyUnitModelLookup: "model-property-unit-model-lookup",
  modelPropertyParameterLookup: "model-property-parameter-lookup",
  tireMakeList: "tire-make-list",
  tireMakeDetail: "tire-make-detail",
  tireModelList: "tire-model-list",
  tireModelDetail: "tire-model-detail",
  parameterGroupList: "parameter-group-list",
  parameterGroupLookup: "parameter-group-lookup",
  parameterGroupColumns: "parameter-group-columns",
  parameterList: "parameter-list",
  parameterLookup: "parameter-lookup",
  parameterColumns: "parameter-columns",
  customerTypeList: "customer-type-list",
  customerTypeColumns: "customer-type-columns",
  customerSourceList: "customer-source-list",
  customerSourceColumns: "customer-source-columns",
  corporationPositionList: "corporation-position-list",
  corporationPositionColumns: "corporation-position-columns",
  businessActivitiesList: "business-activities-list",
  businessActivitiesColumns: "business-activities-columns",
  systemTypeList: "system-type-list",
  tireMeasureList: "tire-measure-list",
  tireMeasureDetail: "tire-measure-detail",
  tirePresetList: "tire-preset-list",
  tirePresetDetail: "tire-preset-detail",
  tachographCardList: "tachograph-card-list",
  tachographCardColumns: "tachograph-card-columns",
  tachographCardDetail: "tachograph-card-detail",
  rawDataLog: "raw-data-log",
  rawDataDeviceLookup: "raw-data-device-lookup",
  tpmsTireSchema: "tpms-tire-schema",
  tpmsPresetLookup: "tpms-preset-lookup",
  tpmsPresetList: "tpms-preset-list",
  tpmsPresetDetail: "tpms-preset-detail",
  tpmsVehicleSetting: "tpms-vehicle-setting",
  tpmsTireMakeLookup: "tpms-tire-make-lookup",
  tpmsTireModelLookup: "tpms-tire-model-lookup",
  tpmsTireMeasureLookup: "tpms-tire-measure-lookup",
} as const;

export const QueryNames = {
  exampleList: [QueryModuleNames.exampleList],
  exampleLookup: [QueryModuleNames.exampleLookup],
  customerList: [QueryModuleNames.customerList],
  customerStats: [QueryModuleNames.customerStats],
  customerLimits: [QueryModuleNames.customerLimits],
  auditLogList: [QueryModuleNames.auditLogList],
  clientLookup: [QueryModuleNames.clientLookup],
  clientPresetLookup: [QueryModuleNames.clientPresetLookup],
  clientTypeLookup: [QueryModuleNames.clientTypeLookup],
  clientStatusLookup: [QueryModuleNames.clientStatusLookup],
  languageLookup: [QueryModuleNames.languageLookup],
  countryLookup: [QueryModuleNames.countryLookup],
  referenceCountries: [QueryModuleNames.referenceCountries],
  temperatureLookup: [QueryModuleNames.temperatureLookup],
  currencyLookup: [QueryModuleNames.currencyLookup],
  weightLookup: [QueryModuleNames.weightLookup],
  volumeLookup: [QueryModuleNames.volumeLookup],
  fuelLookup: [QueryModuleNames.fuelLookup],
  distanceLookup: [QueryModuleNames.distanceLookup],
  positionLookup: [QueryModuleNames.positionLookup],
  productLookup: [QueryModuleNames.productLookup],
  clientSourceLookup: [QueryModuleNames.clientSourceLookup],
  clientCompetitorLookup: [QueryModuleNames.clientCompetitorLookup],
  clientPositionTypeLookup: [QueryModuleNames.clientPositionTypeLookup],
  paymentTypeLookup: [QueryModuleNames.paymentTypeLookup],
  paymentLookup: [QueryModuleNames.paymentLookup],
  paymentSubsUnitLookup: [QueryModuleNames.paymentSubsUnitLookup],
  pprPaymentTermLookup: [QueryModuleNames.pprPaymentTermLookup],
  tireMakeLookup: [QueryModuleNames.tireMakeLookup],
  vehicleList: [QueryModuleNames.vehicleList],
  commandHistoryList: [QueryModuleNames.commandHistoryList],
  commandLookup: [QueryModuleNames.commandLookup],
  commandDetail: [QueryModuleNames.commandDetail],
  commandHistoryDetail: [QueryModuleNames.commandHistoryDetail],
  routeHistory: [QueryModuleNames.routeHistory],
  fuelLevelHistory: [QueryModuleNames.fuelLevelHistory],
  fuelTanks: [QueryModuleNames.fuelTanks],
  fuelProbesCalibration: [QueryModuleNames.fuelProbesCalibration],
  routeSettings: [QueryModuleNames.routeSettings],
  routePresetList: [QueryModuleNames.routePresetList],
  routePresetNames: [QueryModuleNames.routePresetNames],
  routePresetDetail: [QueryModuleNames.routePresetDetail],
  refuelingSettings: [QueryModuleNames.refuelingSettings],
  tachographSettings: [QueryModuleNames.tachographSettings],
  tachographCompanySettings: [QueryModuleNames.tachographCompanySettings],
  refuelingPresetList: [QueryModuleNames.refuelingPresetList],
  refuelingPresetLookup: [QueryModuleNames.refuelingPresetLookup],
  connectivityHeatmap: [QueryModuleNames.connectivityHeatmap],
  deviceIncomingLastValue: [QueryModuleNames.deviceIncomingLastValue],
  deviceMappings: [QueryModuleNames.deviceMappings],
  mappingPresetList: [QueryModuleNames.mappingPresetList],
  mappingPresetDetail: [QueryModuleNames.mappingPresetDetail],
  mappingPresetByDeviceType: [QueryModuleNames.mappingPresetByDeviceType],
  mappingPresetNames: [QueryModuleNames.mappingPresetNames],
  mappingPresetProperties: [QueryModuleNames.mappingPresetProperties],
  temperatureTypeLookup: [QueryModuleNames.temperatureTypeLookup],
  relayStatusLookup: [QueryModuleNames.relayStatusLookup],
  switchOnOffStateTypeLookup: [QueryModuleNames.switchOnOffStateTypeLookup],
  warehouseUnitList: [QueryModuleNames.warehouseUnitList],
  warehouseUnitOperationTypeLookup: [QueryModuleNames.warehouseUnitOperationTypeLookup],
  warehouseUnitHwStatusLookup: [QueryModuleNames.warehouseUnitHwStatusLookup],
  userList: [QueryModuleNames.userList],
  userDetail: [QueryModuleNames.userDetail],
  userRoleLookup: [QueryModuleNames.userRoleLookup],
  userDistributorLookup: [QueryModuleNames.userDistributorLookup],
  userClientLanguage: [QueryModuleNames.userClientLanguage],
  userSystems: [QueryModuleNames.userSystems],
  userActivities: [QueryModuleNames.userActivities],
  userDevices: [QueryModuleNames.userDevices],
  userTimedData: [QueryModuleNames.userTimedData],
  distributorLimitations: [QueryModuleNames.distributorLimitations],
  distributorList: [QueryModuleNames.distributorList],
  unitManagementVehicleMakeLookup: [QueryModuleNames.unitManagementVehicleMakeLookup],
  unitManagementVehicleModelLookup: [QueryModuleNames.unitManagementVehicleModelLookup],
  unitManagementVehicleTypeLookup: [QueryModuleNames.unitManagementVehicleTypeLookup],
  unitManagementMaxSpeedLookup: [QueryModuleNames.unitManagementMaxSpeedLookup],
  unitManagementAdjusterLookup: [QueryModuleNames.unitManagementAdjusterLookup],
  unitManagementClientLookup: [QueryModuleNames.unitManagementClientLookup],
  unitManagementUnitSearch: [QueryModuleNames.unitManagementUnitSearch],
  unitManagementInstall: [QueryModuleNames.unitManagementInstall],
  unitManagementVehicleSearch: [QueryModuleNames.unitManagementVehicleSearch],
  unitManagementVehicleDetail: [QueryModuleNames.unitManagementVehicleDetail],
  unitManagementUninstall: [QueryModuleNames.unitManagementUninstall],
  unitManagementUninstallFuelSensor: [QueryModuleNames.unitManagementUninstallFuelSensor],
  unitManagementChange: [QueryModuleNames.unitManagementChange],
  userProfile: [QueryModuleNames.userProfile],
  warehouseTypes: [QueryModuleNames.warehouseTypes],
  warehouseLookup: [QueryModuleNames.warehouseLookup],
  warehouseHierarchyLookup: {
    area: [QueryModuleNames.warehouseAreaLookup],
    lane: [QueryModuleNames.warehouseLaneLookup],
    shelf: [QueryModuleNames.warehouseShelfLookup],
    position: [QueryModuleNames.warehousePositionLookup],
  },
  warehouseHierarchy: {
    warehouse: [QueryModuleNames.warehouseList],
    area: [QueryModuleNames.warehouseAreaList],
    lane: [QueryModuleNames.warehouseLaneList],
    shelf: [QueryModuleNames.warehouseShelfList],
    position: [QueryModuleNames.warehousePositionList],
  },
  unitBrandList: [QueryModuleNames.unitBrandList],
  unitBrandLookup: [QueryModuleNames.unitBrandLookup],
  unitBrandColumns: [QueryModuleNames.unitBrandColumns],
  unitModelList: [QueryModuleNames.unitModelList],
  unitModelColumns: [QueryModuleNames.unitModelColumns],
  unitTypeLookup: [QueryModuleNames.unitTypeLookup],
  temperatureSensorTypeList: [QueryModuleNames.temperatureSensorTypeList],
  temperatureSensorTypeDetail: [QueryModuleNames.temperatureSensorTypeDetail],
  switchOnOffStateList: [QueryModuleNames.switchOnOffStateList],
  switchOnOffStateDetail: [QueryModuleNames.switchOnOffStateDetail],
  relayStatusTypeList: [QueryModuleNames.relayStatusTypeList],
  relayStatusTypeDetail: [QueryModuleNames.relayStatusTypeDetail],
  vehicleTypeList: [QueryModuleNames.vehicleTypeList],
  vehicleMakeList: [QueryModuleNames.vehicleMakeList],
  vehicleMakeLookup: [QueryModuleNames.vehicleMakeLookup],
  vehicleModelList: [QueryModuleNames.vehicleModelList],
  modelPropertyList: [QueryModuleNames.modelPropertyList],
  modelPropertyUnitModelLookup: [QueryModuleNames.modelPropertyUnitModelLookup],
  modelPropertyParameterLookup: [QueryModuleNames.modelPropertyParameterLookup],
  tireMakeList: [QueryModuleNames.tireMakeList],
  tireMakeDetail: [QueryModuleNames.tireMakeDetail],
  tireModelList: [QueryModuleNames.tireModelList],
  tireModelDetail: [QueryModuleNames.tireModelDetail],
  parameterGroupList: [QueryModuleNames.parameterGroupList],
  parameterGroupLookup: [QueryModuleNames.parameterGroupLookup],
  parameterGroupColumns: [QueryModuleNames.parameterGroupColumns],
  parameterList: [QueryModuleNames.parameterList],
  parameterLookup: [QueryModuleNames.parameterLookup],
  parameterColumns: [QueryModuleNames.parameterColumns],
  customerTypeList: [QueryModuleNames.customerTypeList],
  customerTypeColumns: [QueryModuleNames.customerTypeColumns],
  customerSourceList: [QueryModuleNames.customerSourceList],
  customerSourceColumns: [QueryModuleNames.customerSourceColumns],
  corporationPositionList: [QueryModuleNames.corporationPositionList],
  corporationPositionColumns: [QueryModuleNames.corporationPositionColumns],
  businessActivitiesList: [QueryModuleNames.businessActivitiesList],
  businessActivitiesColumns: [QueryModuleNames.businessActivitiesColumns],
  systemTypeList: [QueryModuleNames.systemTypeList],
  tireMeasureList: [QueryModuleNames.tireMeasureList],
  tireMeasureDetail: [QueryModuleNames.tireMeasureDetail],
  tirePresetList: [QueryModuleNames.tirePresetList],
  tirePresetDetail: [QueryModuleNames.tirePresetDetail],
  tachographCardList: [QueryModuleNames.tachographCardList],
  tachographCardColumns: [QueryModuleNames.tachographCardColumns],
  tachographCardDetail: [QueryModuleNames.tachographCardDetail],
  rawDataLog: [QueryModuleNames.rawDataLog],
  rawDataDeviceLookup: [QueryModuleNames.rawDataDeviceLookup],
  tpmsTireSchema: [QueryModuleNames.tpmsTireSchema],
  tpmsPresetLookup: [QueryModuleNames.tpmsPresetLookup],
  tpmsPresetList: [QueryModuleNames.tpmsPresetList],
  tpmsPresetDetail: [QueryModuleNames.tpmsPresetDetail],
  tpmsVehicleSetting: [QueryModuleNames.tpmsVehicleSetting],
  tpmsTireMakeLookup: [QueryModuleNames.tpmsTireMakeLookup],
  tpmsTireModelLookup: [QueryModuleNames.tpmsTireModelLookup],
  tpmsTireMeasureLookup: [QueryModuleNames.tpmsTireMeasureLookup],
} as const;

export const globalReactQueryGetOption = {
  refetchOnMount: "always" as const,
};

export const PAGE_SIZE = 10;
export const PAGE_NUMBER = 0;
export const PAGINATION_STALE_TIME = 5000;

export const QUERY_CONSTANTS = {
  AUTH: {
    LOGIN: "login",
    LOGOUT: "logout",
    PROFILE: "profile",
    REFRESH: "refresh",
  },
  USER: {
    LIST: "user-list",
    DETAIL: "user-detail",
  },
  CUSTOMER: {
    LIST: "customer-list",
    DETAIL: "customer-detail",
    STATS: "customer-stats",
  },
} as const;
